import React from 'react';

import { motion } from 'framer-motion';

import { features } from '../data/features';

interface FeaturesProps {
  className?: string;
  title?: string;
  subtitle?: string;
}

const Features: React.FC<FeaturesProps> = ({ className = '', title, subtitle }) => {
  return (
    <section className={`py-12 ${className}`}>
      {(title || subtitle) && (
        <div className="text-center mb-12">
          {title && <h2 className="text-3xl font-bold text-gray-900 mb-4">{title}</h2>}
          {subtitle && <p className="text-xl text-gray-600">{subtitle}</p>}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map(feature => (
          <motion.div
            key={feature.id}
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 400, damping: 10 }}
            className="p-6 rounded-xl bg-white shadow-xl hover:shadow-2xl transition-all"
          >
            <div className="bg-blue-50 p-3 rounded-lg inline-block mb-4">
              <feature.icon className="h-8 w-8 text-[#003366]" />
            </div>
            <h3 className="mt-4 text-xl font-bold">{feature.title}</h3>
            <p className="mt-2 text-gray-600">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Features;
